import { createSelector } from 'reselect'
import getInfoDataSquadSelect from 'modules/squad/redux/selectors/get-info-data'

const getNameSquadSelect = createSelector(
  getInfoDataSquadSelect,
  /**
   * @param {import('modules/squad/types').GetSquadInfoResp} squadInfoData
   */
  (squadInfoData) => {
    return squadInfoData?.squad_name
  }
)

export default getNameSquadSelect
